import { Navigate } from 'react-router';

import { currentOnboardingStep, useAuthStore } from '@/store';

import { onboardingPathForStep } from '../lib/onboarding-routing';

/**
 * Index redirect for `/onboarding` — sends the user straight to whichever
 * step they're currently on (or step 1 if we don't know yet).
 */
export function OnboardingIndexRedirect() {
  const user = useAuthStore((s) => s.user);
  return <Navigate to={onboardingPathForStep(currentOnboardingStep(user))} replace />;
}
